import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "My Banks"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Create and File Disputes with your bank")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card mb-5 mb-xl-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-stretch pb-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar m-0" }, [
      /*#__PURE__*/_createElementVNode("ul", {
        class: "nav nav-stretch nav-line-tabs border-transparent",
        role: "tablist"
      }, [
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("a", {
            id: "kt_billing_creditcard_tab",
            class: "nav-link fs-5 fw-bold me-5 active",
            "data-bs-toggle": "tab",
            role: "tab",
            href: "#kt_billing_creditcard",
            "aria-selected": "true"
          }, " Credit / Debit Card ")
        ]),
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("a", {
            id: "kt_billing_paypal_tab",
            class: "nav-link fs-5 fw-bold",
            "data-bs-toggle": "tab",
            role: "tab",
            href: "#kt_billing_paypal",
            "aria-selected": "false",
            tabindex: "-1"
          }, " Paypal ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "container p-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row gx-9 gy-6" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-xl-6",
        "data-kt-billing-element": "card"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column py-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-4 fw-bold mb-5" }, [
              /*#__PURE__*/_createTextVNode(" Marcus Morris "),
              /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success fs-7 ms-2" }, "Primary")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "/metronic8/demo1/assets/media/svg/card-logos/visa.svg",
                alt: "",
                class: "me-4"
              }),
              /*#__PURE__*/_createElementVNode("div", null, [
                /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "Visa **** 1679"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-semibold text-gray-400" }, " Card expires at 09/24 ")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center py-2" }, [
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary me-3",
              "data-kt-billing-action": "card-delete"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Delete"),
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
                /*#__PURE__*/_createTextVNode(" Please wait... "),
                /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_new_card"
            }, " Edit ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-xl-6",
        "data-kt-billing-element": "card"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column py-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-4 fw-bold mb-5" }, " MACU - Mountain America "),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "/media/svg/card-logos/american-express.svg",
                alt: "",
                class: "me-4 w-80px"
              }),
              /*#__PURE__*/_createElementVNode("div", null, [
                /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "Mastercard **** 2040"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-semibold text-gray-400" }, " Card expires at 10/22 ")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center py-2" }, [
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary me-3",
              "data-kt-billing-action": "card-delete"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Delete"),
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
                /*#__PURE__*/_createTextVNode(" Please wait... "),
                /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_new_card"
            }, " Edit ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "col-xl-6",
        "data-kt-billing-element": "card"
      }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column py-2" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fs-4 fw-bold mb-5" }, " Morris, M.M "),
            /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
              /*#__PURE__*/_createElementVNode("img", {
                src: "/metronic8/demo1/assets/media/svg/card-logos/mastercard.svg",
                alt: "",
                class: "me-4"
              }),
              /*#__PURE__*/_createElementVNode("div", null, [
                /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-bold" }, "Mastercard **** 1290"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-semibold text-gray-400" }, " Card expires at 03/23 ")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center py-2" }, [
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary me-3",
              "data-kt-billing-action": "card-delete"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Delete"),
              /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
                /*#__PURE__*/_createTextVNode(" Please wait... "),
                /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
              ])
            ]),
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-sm btn-light btn-active-light-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_new_card"
            }, " Edit ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-xl-6" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-3 mb-md-0 fw-semibold" }, [
              /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-900 fw-bold" }, "Important Note!"),
              /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-700 pe-7" }, [
                /*#__PURE__*/_createTextVNode(" Your Issuing institution "),
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "fw-bold me-1"
                }, "Dispute Resolution"),
                /*#__PURE__*/_createTextVNode(" fax number or "),
                /*#__PURE__*/_createElementVNode("br"),
                /*#__PURE__*/_createTextVNode(" email is required to complete. ")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-primary px-6 align-self-center text-nowrap",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_new_card"
            }, " Add Bank ")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, _hoisted_3, 2))
}